import { PagedTable } from 'bold-ui'
import { TableBox } from 'components/table'
import { usePagedTableProps } from 'components/table/usePagedTableProps'
import { AtendimentosFinalizadosQuery } from 'graphql/types.generated'
import { Dispatch } from 'react'

import { convertAtendProfToAssinaturaEletronicaRowModel } from '../converter-assinaturaEletronicaAtend'
import {
  AssinaturaEletronicaAtendTableFilterModel,
  AssinaturaEletronicaAtendTableRowModel,
} from '../model-assinaturaEletronicaAtend'
import {
  renderActions,
  renderCidadao,
  renderDataHora,
  renderTags,
  renderTipoAtendimento,
} from './renderAssinaturaEletronicaAtendTable'

export interface AssinaturaEletronicaAtendTableProps {
  setCurrentFilter: Dispatch<React.SetStateAction<AssinaturaEletronicaAtendTableFilterModel>>
  data: AtendimentosFinalizadosQuery
  loading: boolean
  refetch: () => void
}

export function AssinaturaEletronicaAtendTable(props: AssinaturaEletronicaAtendTableProps) {
  const { data, loading, setCurrentFilter, refetch } = props

  const tableProps = usePagedTableProps({
    result: data.atendimentosFinalizados,
    loading: loading,
    onChange: setCurrentFilter,
  })

  const atendimentosFinalizados =
    data.atendimentosFinalizados?.content.filterNotNull().map(convertAtendProfToAssinaturaEletronicaRowModel) ?? []

  return (
    <TableBox>
      <PagedTable<AssinaturaEletronicaAtendTableRowModel>
        {...tableProps}
        rows={atendimentosFinalizados}
        columns={[
          {
            header: 'Registrado em',
            name: 'dataRegistro',
            render: renderDataHora,
          },
          {
            header: 'Tipo de documento',
            name: 'tipoAtendimento',
            render: renderTipoAtendimento,
          },
          {
            header: 'Cidadão',
            name: 'cidadao',
            render: renderCidadao,
          },
          {
            name: 'status',
            render: renderTags,
          },
          {
            name: 'icon',
            render: (row) => renderActions(row, refetch),
          },
        ]}
      />
    </TableBox>
  )
}
